var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useFragment } from '@apollo/client/react';
import { Trans } from '@lingui/react/macro';
import { Menu } from '@pocketlaw/tetris';
import { useField, useFormikContext } from 'formik';
import { AddMetadataLabelFragmentFragmentDoc } from './AddMetadataLabelFragment.gql';
import { RemoveSelection } from './RemoveSelection';
export function AddMetadataBooleanSelection(props) {
    const { from } = props;
    const { submitForm } = useFormikContext();
    const [field, , helpers] = useField('value');
    const { data, complete } = useFragment({
        from,
        fragment: AddMetadataLabelFragmentFragmentDoc,
    });
    const handleSelect = (value) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield helpers.setValue(value);
            return submitForm();
        }
        catch (error) {
            return undefined;
        }
    });
    if (!complete) {
        return null;
    }
    return (<Menu.ItemNested target={data.label}>
      <Menu.Item selected={field.value === true} onClick={() => handleSelect(true)}>
        <Trans comment="Metadata: Add metadata boolean pair - Yes value">Yes</Trans>
      </Menu.Item>
      <Menu.Item selected={field.value === false} onClick={() => handleSelect(false)}>
        <Trans comment="Metadata: Add metadata boolean pair - No value">No</Trans>
      </Menu.Item>
      <RemoveSelection />
    </Menu.ItemNested>);
}
